import { ReactNode } from "react";
import {
  SkipLink,
  SkipLinkWrapper,
  SkipNavigationContentWrapper,
} from "./__styles__/SkipNavigation";

export const SKIP_NAVIGATION_TARGET_ID = "main-content";

interface SkipNavigationProps {
  /**
   * The ID of the target element to skip to.
   */
  targetId?: string;
  /**
   * The skip link test. Opt for language that points to the action that will be
   * performed (e.g. "Skip to main content").
   */
  buttonText?: string;
}

export const SkipNavigation = ({
  targetId = `#${SKIP_NAVIGATION_TARGET_ID}`,
  buttonText = "Skip to main content",
}: SkipNavigationProps) => {
  return (
    <SkipLinkWrapper>
      <SkipLink href={targetId}>{buttonText}</SkipLink>
    </SkipLinkWrapper>
  );
};

type SkipNavigationContentProps = {
  /**
   * The ID of the container. If overriding the default value, ensure the passed
   * value matches the ID passed to the SkipNavigationComponent.
   */
  id?: string;
  dataTestId?: string;
  children: ReactNode;
};

/**
 * Wrap the main content on a page with this element to ensure SkipNavigation
 * works as intended. If applying the ID manually, ensure the element wrapping
 * the main content also has a tabIndex of -1.
 */
export const SkipNavigationContent = ({
  id = SKIP_NAVIGATION_TARGET_ID,
  dataTestId,
  children,
}: SkipNavigationContentProps) => {
  return (
    <SkipNavigationContentWrapper
      id={id}
      tabIndex={-1}
      data-testid={dataTestId}
    >
      {children}
    </SkipNavigationContentWrapper>
  );
};
